import { createFileRoute } from "@tanstack/react-router";
import Profile from "@/pages/Profile";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Mi perfil",
  "pt-BR": "Meu perfil",
  "en": "My profile",
  "en-EU": "My profile",
};

export const Route = createFileRoute("/profile")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/profile", loaderData),
  component: Profile,
});
